import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";

export function translateLoaderService(http: HttpClient) {
    return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}
